// frontend/src/pages/Socrates/components/Dashboard/OverviewCards/index.js

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faGlobe, faUsers, faCog, 
  faCheckCircle, faArrowRight 
} from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import SocratesCard from '../../common/SocratesCard';
import styles from './OverviewCards.module.css';

const OverviewCards = ({ stats, onNavigate }) => {
  const { t } = useLanguage();

  const cards = [
    {
      id: 'total-templates',
      title: t('total_templates'),
      value: stats.totalTemplates,
      icon: faCog,
      color: 'primary',
      onClick: () => onNavigate('templates')
    },
    {
      id: 'system-templates',
      title: t('system_templates'),
      value: stats.systemTemplates,
      icon: faGlobe,
      color: 'info',
      onClick: () => onNavigate('templates')
    },
    {
      id: 'user-templates',
      title: t('user_templates'),
      value: stats.userTemplates,
      icon: faUsers,
      color: 'secondary',
      onClick: () => onNavigate('templates')
    },
    {
      id: 'active-templates',
      title: t('active_templates'),
      value: stats.activeTemplates,
      icon: faCheckCircle,
      color: 'success',
      onClick: () => onNavigate('templates')
    }
  ];

  return (
    <div className={styles.overviewCards}>
      {cards.map((card) => (
        <SocratesCard
          key={card.id}
          className={`${styles.overviewCard} ${styles[card.color]}`}
          onClick={card.onClick}
          variant="elevated"
        >
          <div className={styles.cardContent}>
            <div className={styles.cardLeft}>
              <div className={styles.iconContainer}>
                <FontAwesomeIcon icon={card.icon} className={styles.cardIcon} />
              </div>
              <div className={styles.cardInfo}>
                <h3 className={styles.cardTitle}>{card.title}</h3>
                <p className={styles.cardValue}>{card.value}</p>
              </div>
            </div>
            <div className={styles.cardRight}>
              <FontAwesomeIcon icon={faArrowRight} className={styles.arrowIcon} />
            </div>
          </div>
        </SocratesCard>
      ))}
    </div>
  );
};

export default OverviewCards;